// Loads gm-hud's runtime config (locations + users and their per-user permissions) from
// games-cloud's /gm-hud-config endpoint, which serves the staff-sheet-sourced users (cached
// hourly). This is the single source of truth — games-cloud must be reachable for the app to
// work (auth already depends on it), so there is no static fallback.

// lanAware swaps a localhost games-cloud URL for the page's own host when the HUD is opened on
// the laptop's LAN address (http://192.168.x.x:3000) for a phone test: the phone cannot reach
// localhost, and Chrome blocks a LAN-served page from calling localhost at all. Production URLs
// are never localhost, so this is a no-op there.
export function lanAware(url) {
    const host = typeof window !== "undefined" ? window.location.hostname : "";
    if (!host || /^(localhost|127\.0\.0\.1)$/.test(host)) return url;
    return url.replace(/^(wss?|https?):\/\/(localhost|127\.0\.0\.1)(?=[:/])/, `$1://${host}`);
}

export const GAMES_CLOUD_BASE = lanAware(
    (process.env.REACT_APP_GAMES_CLOUD_URL || "")
        .replace(/^ws/, "http")
        .replace(/ws$/, ""),
);

// The answer is memoised for the life of the page: the Topbar asks on every page change, and the
// sheet behind it is re-read hourly at best. A failed load is not cached, so a games-cloud hiccup
// does not leave the app permission-less until reload.
let pending = null;

export async function loadGmHudConfig() {
    if (!GAMES_CLOUD_BASE) return null;
    if (pending) return pending;
    pending = (async () => {
        try {
            const r = await fetch(`${GAMES_CLOUD_BASE}gm-hud-config`);
            if (r.ok) return await r.json();
        } catch { /* games-cloud unreachable */ }
        pending = null;
        return null;
    })();
    return pending;
}
